// In /api/printUtils.js

import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

/**
 * Handles PDF action based on the device type for maximum reliability:
 * - On Mobile: Triggers a direct file download.
 * - On Desktop: Opens the PDF in a new tab for viewing.
 *
 * @param {string} docno
 * @param {string} finyear
 * @param {string} doctype
 * @param {Window | null} [pdfWindow=null] - Optional window handle from a modal.
 */
export const handlePrint = async (docno, finyear, doctype, pdfWindow = null) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Authentication error. Please log in again.");
      if (pdfWindow) pdfWindow.close();
      return;
    }

    const response = await axios.get(
      `${API_BASE_URL}/document/print/${docno}/${finyear}?doctype=${doctype}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );

    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(pdfBlob);

    // --- Device-Specific Logic ---
    const isMobile = /Mobi/i.test(window.navigator.userAgent);

    if (isMobile && !pdfWindow) {
      // 1. On MOBILE, trigger a direct DOWNLOAD.
      const fileName = `${doctype.toLowerCase()}_${docno}_${finyear}.pdf`;
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

    } else {
      // 2. On DESKTOP (or from the modal on mobile), open in a new tab.
      if (pdfWindow) {
        pdfWindow.location.href = fileURL;
      } else {
        const newWindow = window.open(fileURL, '_blank');
        if (!newWindow) {
          alert("Pop-up blocked! Please allow pop-ups for this site.");
        }
      }
    }
    
    // Clean up the temporary URL to prevent memory leaks.
    setTimeout(() => URL.revokeObjectURL(fileURL), 120000); // MODIFIED: Timeout is now 2 minutes (120000 ms)

  } catch (error) {
    console.error("Failed to process document:", error);
    if (pdfWindow) pdfWindow.close();
    alert("Could not open the document. Please try again.");
  }
};